import w from "./index6.js";
import C from "./index7.js";
import k from "../../../trust_logos/ui/components/index.js";
import v from "./index8.js";
import D from "../../../country_selector/ui/components/index.js";
import { Variants as N } from "../../../country_selector/ui/types/index.js";
import P from "../../../csr_phone_number/ui/components/index.js";
import "../../../shared/data/configuration/state/index2.js";
import "@ado/base-service";
import { createRegionCodeProvider as E } from "@ado/location-library";
import "@ado/cookie-library";
import "../../../shared/data/csr/state/index2.js";
import { getLayout as T } from "../../../shared/data/layout/state/index.js";
import { FooterStyle as r } from "../../../shared/data/layout/state/index3.js";
import "../../../shared/data/location/state/index.js";
import "../../../shared/data/navigation/state/index2.js";
import "@ado/experiment-library";
import "../../../search/state/index2.js";
import "../../../shared/data/user/state/index2.js";
import { useNavigationEventBus as A } from "@ado/acs-standard-library";
import I from "./index9.js";
import R from "./index10.js";
import { defineComponent as _, defineAsyncComponent as q, computed as t } from "vue";
import { PhoneContactInfo as F } from "../types/index4.js";
import { useBaseApplicationTranslation as O } from "../../../shared/libraries/local-translations/index.js";
import j from "./index11.js";
import { submitInternalEvent as B } from "@ado/tracking-library";
import { TRACKING_EVENTS as x } from "../../../shared/data/tracking/types/index.js";
const So = _({
  name: "Footer",
  components: {
    Disclaimer: w,
    Links: v,
    TrustLogos: k,
    SocialLinks: C,
    CountrySelector: D,
    CSRPhoneNumber: P,
    FooterSkeleton: I,
    FooterMobile: R,
    PolicyDialog: q(() => import("./index12.js")),
    FooterLogo: j
  },
  props: {
    footerStyle: {
      type: String,
      default: r.Normal
    },
    disclaimerSettings: {
      type: Object,
      required: !0
    },
    countrySelectorSettings: {
      type: Object,
      required: !0
    },
    footerLinks: {
      type: Array,
      required: !0
    },
    csr: {
      type: Object,
      required: !0
    },
    notLoaded: {
      type: Boolean,
      default: !0
    },
    config: {
      type: Object,
      required: !0
    }
  },
  setup(o) {
    const n = t(
      () => new F(o.csr.phoneNumber, o.csr.phoneHours)
    ), s = t(
      () => o.footerStyle === r.Normal
    ), i = t(
      () => o.footerStyle === r.Simple
    ), a = t(
      () => o.footerStyle === r.SelectionPage
    ), c = t(() => o.footerStyle === r.None), m = t(
      () => o.disclaimerSettings.validate()
    ), l = t(
      () => i.value || o.config.sitebrand !== "Doculaw" && o.config.sitebrand !== "LawDepot"
    ), u = t(
      () => !i.value && (o.config.sitebrand === "LawDepot" || o.config.sitebrand === "DocuLaw")
    ), f = E().provideRegionCode(), d = o.countrySelectorSettings.currentCountry.countryCode === "CA" && f === "QC", g = t(() => T().showPolicyDialog), y = O().isLoaded, S = A(), p = () => {
      B(x.HEADER_LAW_DEPOT_CLICK);
    }, L = t(() => o.config.showSocialLinks), h = t(() => o.config.showPhoneHours && o.config.showPhoneNumber), b = t(() => {
      let e = "";
      switch (i.value && (e += "simple-footer "), o.config.sitebrand.toLowerCase()) {
        case "rechtsdokumente":
          e += "trust-logos-rd ";
          break;
        case "documentsl\xE9gaux":
          e += "trust-logos-dl ";
          break;
        case "doculaw":
          e += "trust-logos-dlaw ";
          break;
        default:
          e += "trust-logos-ld ";
          break;
      }
      return e;
    });
    return {
      isNormalStyle: s,
      isSimpleStyle: i,
      isSelectionStyle: a,
      isNoneStyle: c,
      shouldShowDisclaimer: m,
      isQuebec: d,
      countryVariant: N,
      csrInfo: n,
      showPolicyDialog: g,
      areTranslationsLoaded: y,
      navigationEventBus: S,
      trackLogoClick: p,
      showSocialLinks: L,
      showPhoneInfo: h,
      trustLogosClass: b,
      showLeftTrustLogo: l,
      showRightTrustLogo: u
    };
  }
});
export {
  So as default
};
//# sourceMappingURL=index4.js.map
